// src/pages/features/SignIn.tsx
import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { deleteField, doc, updateDoc } from "firebase/firestore";
import { auth, db } from "../../firebase";
import { useNavigate, Link } from "react-router-dom";
import Window, { Footer } from "../../components/Window";
import Icon from "../../components/Icon";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    try {
      const cred = await signInWithEmailAndPassword(auth, email, password);
      // Older profiles stored the email where other members could read it.
      updateDoc(doc(db, "users", cred.user.uid), { email: deleteField() }).catch(
        () => undefined
      );
      navigate("/dashboard");
    } catch (err: any) {
      setError("Invalid email or password. Please try again.");
    }
  };

  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <div className="mb-5 text-center">
          <span className="logo">
            <Icon name="mail" size={37} tone="pink" pop className="mr-1" />
            PenPal Board
            <span className="logo-sub">the 2SLGBTQIA+ pen pal network</span>
          </span>
        </div>

        <Window title="sign_in.exe" minimizable={false}>
          <h1 className="window-heading">
            Welcome back <Icon name="heart" tone="pink" size={26} pop />
          </h1>
          <p className="window-sub">Your letters missed you.</p>

          <form onSubmit={handleLogin} className="flex flex-col gap-4">
            <label className="field">
              <span className="field-label">Email</span>
              <input
                type="email"
                className="input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                required
              />
            </label>
            <label className="field">
              <span className="field-label">Password</span>
              <input
                type="password"
                className="input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
            </label>

            <Link to="/forgot-password" className="-mt-2 self-end text-sm">
              Forgot your password?
            </Link>

            {error && <p className="error-text">{error}</p>}

            <button type="submit" className="btn w-full">
              Sign in ✿
            </button>
          </form>

          <div className="divider my-4" />

          <p className="text-center text-sm">
            New here? <Link to="/signup">Make an account</Link>
          </p>
        </Window>

        <Footer />
      </div>
    </div>
  );
};

export default SignIn;
